// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"a19539ea","217":"3c4502bd","285":"62a35e98","774":"4841fc52","883":"d946a3bc","910":"4c9cf3ad"}[chunkId] + ".chunk.js";
};